import type { BlockOpenAPIWebhookData } from '@gitbook/doc-core';
import type { BlockProps } from '@gitbook/slate-react';

import { BlockOpenAPIFetchWrapper } from './BlockOpenAPIFetchWrapper';
import { OpenAPIWebhookBlockContent } from './OpenAPIWebhook';

/**
 * Component to render a openapi-webhook block.
 */
export function BlockOpenAPIWebhook(props: BlockProps) {
    const data = props.node.data.toFrozenObject<BlockOpenAPIWebhookData>();
    const { name, method } = data;

    return (
        <BlockOpenAPIFetchWrapper {...props} data={data}>
            {({ filesystem, specUrl }) => {
                return (
                    <OpenAPIWebhookBlockContent
                        specUrl={specUrl}
                        filesystem={filesystem}
                        name={name}
                        method={method}
                    />
                );
            }}
        </BlockOpenAPIFetchWrapper>
    );
}
